import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { __importDefault } from 'tslib';

declare let d3: any;
import * as _ from 'lodash';

@Component({
  selector: 'app-grouped-stack-chart',
  templateUrl: './grouped-stack-chart.component.html',
  styleUrls: ['./grouped-stack-chart.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class GroupedStackChartComponent implements OnInit {

  @Input() gridData;
  @ViewChild('groupedStackChart') chartElement: ElementRef;
  constructor() { }

  ngOnInit() {
    this.loadChart(_.map(this.gridData.data, _.clone));
  }

  loadChart(data) {
    var margin = { top: 40, right: 20, bottom: 30, left: 65 },
      width = 700 - margin.left - margin.right,
      height = 500 - margin.top - margin.bottom;

    var x0 = d3.scale.ordinal()
      .rangeRoundBands([0, width], 0.4);

    var x1 = d3.scale.ordinal();

    var y = d3.scale.linear()
      .range([height, 0]);

    var xAxis = d3.svg.axis()
      .scale(x0)
      .orient("bottom");

    var yAxis = d3.svg.axis()
      .scale(y)
      .orient("left")
      .tickFormat(d3.format(".2s"));

    var color = d3.scale.ordinal()
      .range(["#f36152", "#2fbcd1"]);

    var svg = d3.select(this.chartElement.nativeElement).append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var yBegin;

    var innerColumns = {
      "column": ["Writer", "Non Writer"]
    }

    var columnHeaders = d3.keys(data[0]).filter(function (key) { return key !== "PerformanceBand"; });
    color.domain(d3.keys(data[0]).filter(function (key) { return key !== "PerformanceBand"; }));
    data.forEach(function (d) {
      var yColumn = new Array();
      d.columnDetails = columnHeaders.map(function (name) {
        for (let ic in innerColumns) {
          if (innerColumns[ic] && (_.indexOf(innerColumns[ic], name) >= 0)) {
            if (!yColumn[ic]) {
              yColumn[ic] = 0;
            }
            yBegin = yColumn[ic];
            yColumn[ic] += +d[name];
            return { name: name, column: ic, yBegin: yBegin, yEnd: +d[name] + yBegin, };
          }
        }
      });
      d.total = d3.max(d.columnDetails, function (d) {
        return d.yEnd;
      });
    });

    x0.domain(data.map(function (d) { return d.PerformanceBand; }));
    x1.domain(d3.keys(innerColumns)).rangeRoundBands([0, x0.rangeBand()]);

    y.domain([0, d3.max(data, function (d) {
      return d.total;
    })]);

    svg.append("g")
      .attr("class", "x axis text-font")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    // svg.append("g")
    //   .attr("class", "y axis text-font")
    //   .style('opacity', '0')
    //   .call(yAxis)
    //   .append("text")
    //   .attr("transform", "rotate(-90)")
    //   .attr("y", 6)
    //   .attr("dy", ".7em")
    //   .style("text-anchor", "end")
    //   .text("Value");

    svg.append("g")
      .attr("class", "y axis text-font")
      .style('opacity', '0')
      .call(yAxis)
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", -45)
      .attr("x", -(height / 2) + 25)
      .attr("dy", "-0.6em")
      .style("text-anchor", "end")
      .style('font-weight', 'bold')
      .text("Value");

    svg.select('.y').transition().duration(500).delay(1300).style('opacity', '1');

    var project_stackedbar = svg.selectAll(".project_stackedbar")
      .data(data)
      .enter().append("g")
      .attr("class", "g")
      .attr("transform", function (d) { return "translate(" + x0(d.PerformanceBand) + ",0)"; });

    project_stackedbar.selectAll("rect")
      .data(function (d) { return d.columnDetails; })
      .enter().append("rect")
      .attr("width", x1.rangeBand())
      .attr("x", function (d) {
        return x1(d.column);
      })
      .attr("y", function (d) {
        return y(0);
      })
      .attr("height", function (d) {
        return y(0) - y(0);
      })
      .style("fill", function (d) { return color(d.name); })
      .on("mouseover", function (d) {
          d3.select(this).style("fill", d3.rgb(color(d.name)).darker(1));
          div.style('display', 'inline');
        })
      .on("mousemove",
        function (d) {
          div
            .html(d.yEnd - d.yBegin)
            .style('left', (d3.event.pageX + 15) + 'px')
            .style('top', (d3.event.pageY - 20) + 'px');
        }
      ).on('mouseout', function(d) {
        d3.select(this).style("fill", color(d.name));

        div.style('display', 'none');
      });



    project_stackedbar.selectAll("rect")
      .transition()
      .delay(function (d) { return Math.random() * 1000; })
      .duration(1000)
      .attr("y", function (d) { return y(d.yEnd); })
      .attr("height", function (d) { return y(d.yBegin) - y(d.yEnd); });

    //Legend
    var legend = svg.selectAll(".legend")
      .data(this.gridData.legends)
      .enter().append("g")
      .attr("class", "legend")
      //.attr("transform", function (d, i) { console.log("i: ",i); return "translate(0," + i * 20 + ")"; })
      //.attr("transform", function (d, i) { return "translate("+ margin.left+", "+margin.right+")"; })
      .attr("transform", function (d, i) { return "translate(" + (i == 0 ? -60 : -175) + ", -35)"; })
      .style("opacity", "0");


    legend.append("rect")
      .attr("x", width - 18)
      .attr("width", 18)
      .attr("height", 18)
      .style("fill", function (d) { return color(d); });

    legend.append("text")
      .attr("x", width - 24)
      .attr("y", 9)
      .attr("dy", ".35em")
      .attr("class", "text-font")
      .style("text-anchor", "end")
      .style("fill", "#000")
      .text(function (d) { return d; });

    legend.transition().duration(500).delay(function (d, i) { return 1300 + 100 * i; }).style("opacity", "1");

    var div = d3.select('body').append('div')
      .attr('class', 'graph-tooltip dark')
      .attr('id', 'grouped-stack-chart-custom-tooltip')
      .style('display', 'none');

  }
  OnDestroy() {
    d3.select("#grouped-stack-chart-custom-tooltip").remove();
  }

}
